var _path, _path2, _g, _circle, _circle2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnNoFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 71,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.525.694l2.62 6.546c.113.28.335.502.615.615l6.546 2.62c.925.37.925 1.68 0 2.05l-6.546 2.62c-.28.113-.502.335-.614.615l-2.62 6.546c-.37.925-1.68.925-2.05 0L7.855 15.76a1.105 1.105 0 00-.615-.615l-6.546-2.62c-.925-.37-.925-1.68 0-2.05l6.546-2.62c.28-.113.503-.335.615-.615l2.62-6.546c.37-.925 1.68-.925 2.05 0z",
    fill: "#EAEAEB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icn-no-feedback_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 9,
    width: 62,
    height: 62
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M24 9h62v62H24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icn-no-feedback_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.498 55.498l-7.04 7.04c-.602.603-1.302.74-2.098.41-.797-.33-1.195-.919-1.195-1.766V18.04c0-1.033.387-1.938 1.163-2.712.774-.775 1.679-1.163 2.712-1.163h43.917c1.033 0 1.937.388 2.712 1.163.775.774 1.163 1.679 1.163 2.712v33.583c0 1.034-.388 1.938-1.163 2.713-.775.775-1.679 1.162-2.712 1.162H39.498zm-1.679-3.875h39.138V18.04H33.04v38.75l4.78-5.167z",
    fill: "#D9DADD"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 33,
    r: 3,
    fill: "#D9DADD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 33,
    r: 3,
    fill: "#D9DADD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39c1.5 1 5.4 2.5 13 2.5S67 39 68.5 38",
    stroke: "#D9DADD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.257 38.513l1.937 4.838a.815.815 0 00.454.455l4.839 1.936c.684.274.684 1.242 0 1.516l-4.838 1.936a.817.817 0 00-.455.455l-1.937 4.838c-.273.684-1.241.684-1.515 0l-1.936-4.838a.815.815 0 00-.455-.455l-4.838-1.936c-.684-.274-.684-1.242 0-1.516l4.838-1.936a.817.817 0 00.455-.455l1.936-4.838c.274-.684 1.242-.684 1.515 0zM14.191 59.383a2.191 2.191 0 100-4.383 2.191 2.191 0 000 4.383zM62.191 69.383a2.191 2.191 0 100-4.383 2.191 2.191 0 000 4.383zM90 15a4 4 0 100-8 4 4 0 000 8z",
    fill: "#EAEAEB"
  })));
}
export default SvgIcnNoFeedback;